export default "__VITE_ASSET__459bf7b0__"